import setCalendarProcessingOptions from '../services/setCalendarProcessingOptions';
import initializeCalendarProcessingOptions from '../actions/initializeCalendarProcessingOptions';
import CalendarProcessingOptions from 'owa-service/lib/contract/CalendarProcessingOptions';

/**
 * Trigger a service call to set calendar processing options and mutate the store
 */

export default async function saveCalendarProcessingOptions(
    calendarProcessingOptions: CalendarProcessingOptions
) {
    const response = await setCalendarProcessingOptions(calendarProcessingOptions);

    if (response.WasSuccessful) {
        initializeCalendarProcessingOptions(calendarProcessingOptions);
    }
}
